    <template>
  <div class="footer" v-if="!this.$route.fullPath.startsWith('/admin')">
    <div class="footer-container">
      <div class="column">
        <h3>最新消息
          <v-icon>fa-angle-down</v-icon>
        </h3>
        <a>公告</a>
      </div>
      <div class="column">
        <h3>權益說明
          <v-icon>fa-angle-down</v-icon>
        </h3>
        <router-link to="/terms">會員服務條款</router-link>
        <router-link to="/policy">隱私權保護</router-link>
        <router-link to="/returnPolicy">退換貨條款</router-link>
      </div>
      <div class="column">
        <h3>關於我們
          <v-icon>fa-angle-down</v-icon>
        </h3>
        <a @click="$refs.aboutus.dialog = true">聯絡我們</a>
      </div>
      <div style="clear: both"></div>
    </div>
    <div class="divider"></div>
    <div class="copyright">Copyright © 2020 {{ $TITLE }} All Rights Reserved.</div>
    <AboutUs ref="aboutus"></AboutUs>
  </div>
</template>

<script>
import AboutUs from '@/components/AboutUs'
export default {
  components: { AboutUs },
  mounted() {
    this.columnActiveEvent()
  },
  methods: {
    columnActiveEvent() {
      let columns = document.getElementsByClassName('column')
      columns.forEach(column => {
        column.addEventListener('click', () => {
          column.classList.toggle('active')
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #191919;
  .footer-container {
    max-width: 1300px;
    margin: auto;
    padding: 20px 40px;
    @include tablet {
      padding: 20px 0;
    }
    .column {
      width: 25%;
      font-size: 14px;
      text-align: left;
      font-weight: 200;
      color: white;
      float: left;
      @include tablet {
        width: 50%;
        padding: 10px 40px;
        &:not(.active):not(.company) {
          a {
            display: none;
          }
        }
        &.company {
          width: 100%;
          padding: 20px 40px !important;
        }
      }
      @include mobile {
        padding: 10px 20px;
        &.company {
          padding: 20px 20px !important;
        }
      }
      h3 {
        .v-icon {
          display: none;
          float: right;
          @include tablet {
            display: block;
          }
        }
      }
      &:not(.company) a {
        display: block;
        margin: 15px 0;
        color: lightgrey;
        @media (hover: hover) {
          color: grey;
        }
        &:hover {
          color: lightgrey;
          font-weight: 400;
        }
      }
      &.company {
        padding: 15px;
      }
    }
  }
  .divider {
    color: grey;
    clear: left;
    width: 100%;
    height: 1px;
    background-color: #333333;
  }
  .copyright {
    padding: 10px 0;
    color: lightgrey;
    font-size: 12px;
    font-weight: 200;
    letter-spacing: 1.1px;
    text-align: center;
  }
}
</style>